import script from "./MaterialPlans.vue?vue&type=script&setup=true&lang=js"
export * from "./MaterialPlans.vue?vue&type=script&setup=true&lang=js"

import "./MaterialPlans.vue?vue&type=style&index=0&id=adb73bec&lang=scss&scoped=true"

import exportComponent from "/usr/local/tomcat-jenkins/data/workspace/3d-editor-test/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-adb73bec"]])

export default __exports__